import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_route_tab = _resolveComponent("q-route-tab")!
  const _component_unreviewed_user_clients_posts_tab = _resolveComponent("unreviewed-user-clients-posts-tab")!
  const _component_escalated_user_clients_posts_tab = _resolveComponent("escalated-user-clients-posts-tab")!
  const _component_flagged_user_clients_posts_tab = _resolveComponent("flagged-user-clients-posts-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_overview = _resolveComponent("overview")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_unreviewed_user_clients_posts = _resolveComponent("unreviewed-user-clients-posts")!
  const _component_escalated_user_clients_posts = _resolveComponent("escalated-user-clients-posts")!
  const _component_flagged_user_clients_posts = _resolveComponent("flagged-user-clients-posts")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { padding: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_tabs, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
        "active-color": "primary",
        "active-bg-color": "grey-1",
        "indicator-color": "primary",
        align: "justify",
        "narrow-indicator": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_route_tab, {
            to: "/",
            name: "overview",
            label: "Dashboard",
            exact: ""
          }),
          _createVNode(_component_unreviewed_user_clients_posts_tab),
          _createVNode(_component_escalated_user_clients_posts_tab),
          _createVNode(_component_flagged_user_clients_posts_tab)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_tab_panels, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tab) = $event)),
        class: "bg-grey-1 q-px-md",
        animated: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tab_panel, {
            name: "overview",
            class: "no-scroll"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_overview, {
                "account-id": _ctx.accountId,
                "user-id": _ctx.userId
              }, null, 8, ["account-id", "user-id"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_tab_panel, {
            name: "unreviewed",
            class: "no-scroll"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_unreviewed_user_clients_posts, {
                onTotal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.numUnreviewed = $event))
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_tab_panel, {
            name: "escalated",
            class: "no-scroll"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_escalated_user_clients_posts, {
                onTotal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.numEscalated = $event))
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_tab_panel, {
            name: "flagged",
            class: "no-scroll"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_flagged_user_clients_posts)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}